import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = document.title || 'GiveTech totheBlind';
    trackPageView(pageTitle, window.location.href);
  }, [location]);

  return null;
}